export interface AcaDocumentDto {
  form_id: number;
  paperless_opt_in: boolean;
  year: number;
  organization_name: string;
  uri: string;
  form_download_date?: string;
}

export interface AcaDocumentNewResponseDto {
  forms: AcaDocumentDto[];
  aca_paper_reduction_act_disclaimer?: string;
}

export type AcaDocumentsResponseDto = {
  data: AcaDocumentDto[] | AcaDocumentNewResponseDto;
};

export const hasFormProperty = (
  data: AcaDocumentDto[] | AcaDocumentNewResponseDto
): data is AcaDocumentNewResponseDto => {
  return (data as AcaDocumentNewResponseDto).forms !== undefined;
};
